$(document).ready(function () {
  $("select[name='currency']").change(function (e) {
    if (
      $(this).find("option:selected").attr("data-redirect") ==
      "https://malonesouliers.cn/"
    ) {
      window.location.href = $(this)
        .find("option:selected")
        .attr("data-redirect");
      e.preventDefault();
    }
  });

  $("header .top-center .right ul li.search a").click(function () {
    setTimeout(function () {
      $("#instant-search form.search input").focus();
    }, 500);
  });

  // Autocomplete
  $(".search-results__more a").click(function () {
    $("#instant-search form.search button").click();
    return false;
  });

  $("form.search").on("submit", function (e) {
    e.preventDefault();
    var val = $(this).find("input").val();
    if (val[val.length - 1] != "*") {
      val += "*";
    }
    $(this).find("input").val(val);
    window.location.href =
      window.location.origin + "/search?type=product&q=" + val;
    return false;
  });
});
